import Component from '../../../assets/scripts/modules/component';
import State from '../../../assets/scripts/modules/state';
import fireCustomEvent from '../../../vendor/scripts/fabrique/modules/fire-custom-event';

class Lightbox extends Component {
  init() {

    this.clickOutsideHandler = this.onClickOutside.bind(this);
    this.titleElement = this.element.querySelector('[data-role=title]');
    this.closeButton = this.element.querySelector('[data-role=close]');
    this.lightboxId = this.element.getAttribute('data-id');

    window.addEventListener('lightbox:show', this.onShow.bind(this));
    window.addEventListener('lightbox:changeTitle', this.onChangeTitle.bind(this));
    window.addEventListener('keydown', (e) => {
      if(e.keyCode === 27) {
        this.hide();
      }
    });
    this.closeButton.addEventListener('click', this.onClose.bind(this));
    window.addEventListener('resize', () => {
      if (this.isVisible) {
        this.recalculateSize();
      }
    });
    window.addEventListener('lightbox:resize', () => {
      if (this.isVisible) {
        this.recalculateSize();
      }
    });

    this.resizeTimeout = null;
  }

  onShow(event) {
    if (event.detail.id === this.lightboxId) {
      event.preventDefault();
      this.show();
    }
  }

  onClose(event) {
    event.preventDefault();
    this.hide();
  }

  onChangeTitle(event) {
    if (event.detail.id === this.lightboxId) {
      this.setTitle(event.detail.title);
    }
  }

  setTitle(title = '') {
    this.titleElement.innerText = title;
  }

  initializeSize() {
    const box = this.element.querySelector('.lightbox__box');
    const header = this.element.querySelector('.lightbox__top-bar');
    const content = this.element.querySelector('.lightbox__content');
    box.style.height = 'auto';
    content.style.height = 'auto';
    content.style.width = 'auto';


    setTimeout(function () {
      const headerBounds = header.getBoundingClientRect();
      const contentBounds = content.getBoundingClientRect();
      if (contentBounds.height + headerBounds.height < contentBounds.width) {
        if (content.scrollHeight > contentBounds.height) {
          content.style.height = 'auto';
          box.style.overflow = 'auto';
        } else {
          content.style.height = `${contentBounds.width - headerBounds.height}px`;
          box.style.overflow = 'hidden';
        }
      } else {
        content.style.width = `${contentBounds.height + headerBounds.height}px`;
        content.style.height = '100%';
      }
    }, 100);
  }

  recalculateSize() {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout);
    }
    this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = null;
      this.initializeSize();
    }, 250);
    // const header = this.element.querySelector('.lightbox__top-bar');
    // const content = this.element.querySelector('.lightbox__content');
    // const headerBounds = header.getBoundingClientRect();
    // const contentBounds = content.getBoundingClientRect();
    // content.style.height = `${contentBounds.width - headerBounds.height}px`;
  }

  show() {
    this.isVisible = true;
    this.element.style.opacity = 0;
    this.element.classList.add('is-visible');
    this.initializeSize();

    setTimeout(() => {
      this.element.style.opacity = 1;
      document.body.addEventListener('click', this.clickOutsideHandler);
      State.preventScrolling(true);
    }, 100);
  }

  hide() {
    this.element.classList.remove('is-visible');
    this.isVisible = false;

    document.body.removeEventListener('click', this.clickOutsideHandler);
    State.preventScrolling(false);
    fireCustomEvent('lightbox:hidden', {id: this.lightboxId});
  }

  onClickOutside(event) {

    if (event.target === this.element && this.isVisible) {
      this.hide();
    }
  }
}

for (const element of [...document.querySelectorAll('.lightbox')]) {
  element.instance = new Lightbox('light-box', element, { onLoad: true });
}



// WEBPACK FOOTER //
// ./website/components/atoms/lightbox/lightbox.js